<template>
  <div>
        <section id="menu-area">
          <nav class="navbar-light  navbar-expand-md" role="navigation">
              <div class="header-container d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center mob-new-params">
                    <div class="d-flex align-items-center">
                      <router-link to="/" class="navbar-brand">
                          <img src="/assets/landing/images/logo_1.png" alt="iTender">
                      </router-link>
                      <div class="mob-menu-block ml-3 mob-hide">
                        <img src="/assets/landing/images/menu.svg" class="mob-menu" @click="dropdownFunc">
                        <div id="navbar pl-1" class="position-relative">
                            <ul id="top-menu" class="nav navbar-nav ml-auto mob-nav dropdown-menu" :class="{ 'd-flex' : dropdown}">
                                <li class="nav-item">
                                  <div class="dropdown-menu dropdown-menu-right drop-mob">
                                    <a @click.prevent="$router.push('/dashboard')" class="dropdown-item">
                                      <i class="fas fa-sign-in-alt fa-lg  text-muted mr-2"></i> Դեպի աշխատանքային վահանակ
                                    </a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" @click.prevent="$router.push('/settings')" id="settings_detail_tab"
                                      href="#settings_detail" data-toggle="pill"><i class="dripicons-gear text-muted mr-2"></i> Անձնական
                                      տվյալներ</a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" @click.prevent="$store.dispatch('logout')" href="javascript:void(0)">
                                      <i class="dripicons-exit text-muted mr-2"></i> Ելք համակարգից
                                    </a>
                                  </div>
                                </li>
                                <li class="nav-item" :class="$route.path === '/' && `active`">
                                    <router-link to="/" class="new-nav-link dropdown-item">
                                        {{ $t('menu.home') }}
                                    </router-link>
                                </li>
                                <div class="divider"></div>
                                <li v-if="$route.path === '/' || $route.path === '/#pricing-table'" class="nav-item">
                                    <a href="#" class="new-nav-link dropdown-item" v-scroll-to="'#pricing-table'">Փաթեթներ</a>
                                </li>
                                <li class="nav-item" v-else>
                                    <router-link to="/packages" class="new-nav-link dropdown-item">
                                      Փաթեթներ
                                    </router-link>
                                </li>
                                <div class="divider"></div>
                                <li class="nav-item" :class="$route.path === '/tender' && `active`">
                                    <router-link to="/tender" class="new-nav-link dropdown-item">
                                        {{ $t('menu.tenders') }}
                                    </router-link>
                                </li>
                                <div class="divider"></div>
                                <li class="nav-item " :class="$route.path === '/info' && `active`">
                                    <router-link to="/info" class="new-nav-link dropdown-item">
                                        {{ $t('menu.information') }}
                                    </router-link>
                                </li>
                                <div class="divider"></div>
                                <!-- <li class="nav-item" :class="$route.path === '/help' && `active`">
                                    <router-link to="/help" class="new-nav-link dropdown-item">
                                        {{ $t('menu.help') }}
                                    </router-link>
                                </li>
                                <div class="divider"></div> -->
                                <li class="nav-item" :class="$route.path === '/regulation' && `active`">
                                    <router-link to="/regulation" class="new-nav-link dropdown-item">
                                        {{ $t('menu.regulation') }}
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                      </div>
                    </div>
                    <div class="mob-sm-menu-block">
                      <img src="/assets/landing/images/menu.svg" class="mob-menu" @click="dropdownFunc">
                      <div id="navbar pl-1" class="position-relative">
                          <ul id="top-menu" class="nav navbar-nav ml-auto mob-nav dropdown-menu" :class="{ 'd-flex' : dropdown}">
                              <li class="nav-item" :class="$route.path === '/' && `active`">
                                  <router-link to="/" class="new-nav-link dropdown-item">
                                      {{ $t('menu.home') }}
                                  </router-link>
                              </li>
                              <div class="divider"></div>
                              <li v-if="$route.path === '/' || $route.path === '/#pricing-table'" class="nav-item">
                                  <a href="#" class="new-nav-link dropdown-item" v-scroll-to="'#pricing-table'">Փաթեթներ</a>
                              </li>
                              <li class="nav-item" v-else>
                                  <router-link to="/packages" class="new-nav-link dropdown-item">
                                    Փաթեթներ
                                  </router-link>
                              </li>
                              <div class="divider"></div>
                              <li class="nav-item" :class="$route.path === '/tender' && `active`">
                                  <router-link to="/tender" class="new-nav-link dropdown-item">
                                      {{ $t('menu.tenders') }}
                                  </router-link>
                              </li>
                              <div class="divider"></div>
                              <li class="nav-item " :class="$route.path === '/info' && `active`">
                                  <router-link to="/info" class="new-nav-link dropdown-item">
                                      {{ $t('menu.information') }}
                                  </router-link>
                              </li>
                              <div class="divider"></div>
                              <!-- <li class="nav-item" :class="$route.path === '/help' && `active`">
                                  <router-link to="/help" class="new-nav-link dropdown-item">
                                      {{ $t('menu.help') }}
                                  </router-link>
                              </li>
                              <div class="divider"></div> -->
                              <li class="nav-item" :class="$route.path === '/regulation' && `active`">
                                  <router-link to="/regulation" class="new-nav-link dropdown-item">
                                      {{ $t('menu.regulation') }}
                                  </router-link>
                              </li>
                              <div class="divider"></div>
                              <li class="nav-item" :class="$route.path === '/login' && `active`">
                                  <router-link to="/login" class="new-nav-link dropdown-item">
                                      Մուտք համակարգ
                                  </router-link>
                              </li>
                              <div class="divider"></div>
                              <li class="nav-item" :class="$route.path === '/signup' && `active`">
                                  <router-link to="/signup" class="new-nav-link dropdown-item">
                                      Գրանցվել
                                  </router-link>
                              </li>
                              <div class="divider"></div>
                              <li class="d-flex justify-content-end">
                                <a href="mailto:info@itender.am" class="email-inf-block position-relative d-flex align-items-center">
                                  <svg width="20" height="18" viewBox="0 0 20 18" fill="none">
                                    <path d="M1 0H19C19.2652 0 19.5196 0.105357 19.7071 0.292893C19.8946 0.48043 20 0.734784 20 1V17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H1C0.734784 18 0.48043 17.8946 0.292893 17.7071C0.105357 17.5196 0 17.2652 0 17V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0ZM18 4.238L10.072 11.338L2 4.216V16H18V4.238ZM2.511 2L10.061 8.662L17.502 2H2.511Z" fill="black"/>
                                  </svg>
                                  <p class="mb-0 ml-2 mob-hide">info@itender.am</p>
                                </a>
                                <a href="tel:+37491244970" class="phone-spacing phoneNumber-inf-block position-relative d-flex align-items-center">
                                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path d="M6.366 7.682C7.30434 9.33048 8.66952 10.6957 10.318 11.634L11.202 10.396C11.3442 10.1969 11.5543 10.0569 11.7928 10.0023C12.0313 9.94779 12.2814 9.98254 12.496 10.1C13.9103 10.8729 15.4722 11.3378 17.079 11.464C17.3298 11.4839 17.5638 11.5975 17.7345 11.7823C17.9052 11.9671 18 12.2094 18 12.461V16.923C18.0001 17.1706 17.9083 17.4094 17.7424 17.5932C17.5765 17.777 17.3483 17.8927 17.102 17.918C16.572 17.973 16.038 18 15.5 18C6.94 18 0 11.06 0 2.5C0 1.962 0.027 1.428 0.082 0.898C0.107255 0.651697 0.222984 0.423521 0.40679 0.257634C0.590595 0.0917472 0.829406 -5.33578e-05 1.077 2.32673e-08H5.539C5.79056 -3.15185e-05 6.0329 0.0947515 6.21768 0.265451C6.40247 0.43615 6.51613 0.670224 6.536 0.921C6.66222 2.52779 7.12708 4.08968 7.9 5.504C8.01746 5.71856 8.05221 5.96874 7.99767 6.2072C7.94312 6.44565 7.80306 6.65584 7.604 6.798L6.366 7.682ZM3.844 7.025L5.744 5.668C5.20478 4.50409 4.83535 3.26884 4.647 2H2.01C2.004 2.166 2.001 2.333 2.001 2.5C2 9.956 8.044 16 15.5 16C15.667 16 15.834 15.997 16 15.99V13.353C14.7312 13.1646 13.4959 12.7952 12.332 12.256L10.975 14.156C10.4287 13.9437 9.89801 13.6931 9.387 13.406L9.329 13.373C7.36758 12.2567 5.74328 10.6324 4.627 8.671L4.594 8.613C4.30691 8.10199 4.05628 7.57134 3.844 7.025Z" fill="black"/>
                                  </svg>
                                  <p class="mb-0 ml-2 mob-hide">+37491244970</p> 
                                </a>
                                <a href="http://old.itender.am/" class="phoneNumber-inf-block position-relative d-flex align-items-center mr-3">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-globe" viewBox="0 0 16 16">
                                    <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5H3.82zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068H8.5zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5h2.49zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4h2.355z"/>
                                  </svg>
                                  <p class="mb-0 ml-2 mob-hide">Հին կայք</p> 
                                </a>
                              </li>
                          </ul>
                      </div>
                    </div>
                    <!-- <div id="navbar pl-1" class="position-relative static-menu">
                          <ul id="top-menu" class="nav navbar-nav ml-auto">
                              <li class="nav-item mob-nav-item" :class="$route.path === '/' && `active`">
                                  <router-link to="/" class="new-nav-link dropdown-item">
                                      {{ $t('menu.home') }}
                                  </router-link>
                              </li>
                              <li v-if="$route.path === '/' || $route.path === '/#pricing-table'" class="nav-item">
                                  <a href="#" class="new-nav-link dropdown-item" v-scroll-to="'#pricing-table'">Փաթեթներ</a>
                              </li>
                              <li class="nav-item" v-else>
                                  <router-link to="/packages" class="new-nav-link dropdown-item">
                                    Փաթեթներ
                                  </router-link>
                                  
                              </li>
                              <li class="nav-item mob-nav-item" :class="$route.path === '/tender' && `active`">
                                  <router-link :to="me && userType === 'USER' ? '/participant/tenders' :'/tender'" class="new-nav-link dropdown-item">
                                      {{ $t('menu.tenders') }}
                                  </router-link>
                              </li>
                              <li class="nav-item mob-nav-item" :class="$route.path === '/info' && `active`">
                                  <router-link to="/info" class="new-nav-link dropdown-item">
                                      {{ $t('menu.information') }}
                                  </router-link>
                              </li>
                              <li class="nav-item mob-nav-item" :class="$route.path === '/help' && `active`">
                                  <router-link to="/help" class="new-nav-link dropdown-item">
                                      {{ $t('menu.help') }}
                                  </router-link>
                              </li>
                              <li class="nav-item" :class="$route.path === '/regulation' && `active`">
                                  <router-link to="/regulation" class="new-nav-link dropdown-item">
                                      {{ $t('menu.regulation') }}
                                  </router-link>
                              </li>
                              <li class="nav-item">
                                  <a href="contact.html" class="new-nav-link">{{ $t('home.Կապ') }}</a>
                              </li>
                          </ul>
                    </div> -->
                  </div>
                  <div class="d-flex align-items-center mob-hide">
                    <div class="d-flex mob-contacts">
                      <a href="mailto:info@itender.am" class="email-inf-block position-relative d-flex align-items-center">
                        <svg width="20" height="18" viewBox="0 0 20 18" fill="none">
                          <path d="M1 0H19C19.2652 0 19.5196 0.105357 19.7071 0.292893C19.8946 0.48043 20 0.734784 20 1V17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H1C0.734784 18 0.48043 17.8946 0.292893 17.7071C0.105357 17.5196 0 17.2652 0 17V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0ZM18 4.238L10.072 11.338L2 4.216V16H18V4.238ZM2.511 2L10.061 8.662L17.502 2H2.511Z" fill="black"/>
                        </svg>
                        <!-- <p class="email-inf">info@itender.am</p> -->
                        <p class="mb-0 ml-2">info@itender.am</p>
                      </a>
                      <a href="tel:+37491244970" class="phone-spacing phoneNumber-inf-block position-relative d-flex align-items-center">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <path d="M6.366 7.682C7.30434 9.33048 8.66952 10.6957 10.318 11.634L11.202 10.396C11.3442 10.1969 11.5543 10.0569 11.7928 10.0023C12.0313 9.94779 12.2814 9.98254 12.496 10.1C13.9103 10.8729 15.4722 11.3378 17.079 11.464C17.3298 11.4839 17.5638 11.5975 17.7345 11.7823C17.9052 11.9671 18 12.2094 18 12.461V16.923C18.0001 17.1706 17.9083 17.4094 17.7424 17.5932C17.5765 17.777 17.3483 17.8927 17.102 17.918C16.572 17.973 16.038 18 15.5 18C6.94 18 0 11.06 0 2.5C0 1.962 0.027 1.428 0.082 0.898C0.107255 0.651697 0.222984 0.423521 0.40679 0.257634C0.590595 0.0917472 0.829406 -5.33578e-05 1.077 2.32673e-08H5.539C5.79056 -3.15185e-05 6.0329 0.0947515 6.21768 0.265451C6.40247 0.43615 6.51613 0.670224 6.536 0.921C6.66222 2.52779 7.12708 4.08968 7.9 5.504C8.01746 5.71856 8.05221 5.96874 7.99767 6.2072C7.94312 6.44565 7.80306 6.65584 7.604 6.798L6.366 7.682ZM3.844 7.025L5.744 5.668C5.20478 4.50409 4.83535 3.26884 4.647 2H2.01C2.004 2.166 2.001 2.333 2.001 2.5C2 9.956 8.044 16 15.5 16C15.667 16 15.834 15.997 16 15.99V13.353C14.7312 13.1646 13.4959 12.7952 12.332 12.256L10.975 14.156C10.4287 13.9437 9.89801 13.6931 9.387 13.406L9.329 13.373C7.36758 12.2567 5.74328 10.6324 4.627 8.671L4.594 8.613C4.30691 8.10199 4.05628 7.57134 3.844 7.025Z" fill="black"/>
                        </svg>
                        <!-- <p class="phoneNumber-inf">+37491244970</p> -->
                        <p class="mb-0 ml-2 text-pre">+37491244970</p> 
                      </a>
                      <a href="http://old.itender.am/" class="phoneNumber-inf-block position-relative d-flex align-items-center mr-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-globe" viewBox="0 0 16 16">
                          <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5H3.82zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068H8.5zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5h2.49zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4h2.355z"/>
                        </svg>
                        <p class="mb-0 ml-2 mob-hide text-pre">Հին կայք</p>
                      </a>
                    </div>
                    <div class="d-flex">
                      <router-link tag="button" to="/login" class="land-login">մուտք</router-link>
                      <router-link tag="button" to="/signup" class="land-auth">Գրանցվել</router-link>
                    </div>
                  </div>
              </div>
          </nav>
        </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      dropdown: false,
      showId: 0,
    }
  },
  computed: {
    lng() {
      return this.$store.getters["user/locale"];
    },
    me() {
      return this.$store.getters['user/me']
    },
    userType() {
      return this.$store.getters.userType
    },
  },
  methods:{
    chngelng(lng){
      this.$store.dispatch("user/setLocale",lng);
      this.$i18n.locale = this.lng;
    },
    goToPackages(){
      this.$router.push(`/`);
      this.$router.push(`/?to=pricing-table`);
    },
    dropdownFunc(){
      this.dropdown = !this.dropdown
    },
    consoleLog(data){
      console.log(data)
    },
  },  
  props: ['pageTitle', 'innerMenuWidth'],
  mounted() {
    // console.log(this.$route.path)
  }
}
</script>
<style scoped>
  .header-container {
      padding: 30px 8%;
  }
  .divider{
    height: 0;
    margin: .5rem 0;
    overflow: hidden;
    border-top: 1px solid #f1f5fa;
  }
  .land-login{
  background: #43B4B2;
  border-radius: 50px;
  width: 141px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: 0;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  text-transform: capitalize;
  color: #FFFFFF;
  }
  .land-auth{
  background: #1E7BB7;
  border-radius: 50px;
  width: 141px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: 0;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  text-transform: capitalize;
  color: #FFFFFF;
  margin-left: 20px;
  }
  .text-pre{
    white-space: pre;
  }
  /* .email-inf{
    display: none;
  }
  .email-inf-block:hover .email-inf{
    display: block !important;
    position: absolute;
    top: 25px;
    background-color: rgba(30, 123, 183, 1);
    border-radius: 20px;
    padding: 5px 10px;
    color: white;
    right: 0;
  }
  .phoneNumber-inf{
    display: none;
  }
  .phoneNumber-inf-block:hover .phoneNumber-inf{
    display: block !important;
    position: absolute;
    bottom: 25px;
    background-color: rgba(30, 123, 183, 1);
    border-radius: 20px;
    padding: 5px 10px;
    color: white;
  } */
  .mob-menu{
    width: 36px;
    cursor: pointer;
  }
  .dropdown-menu{
    width: fit-content;
    min-width: fit-content !important;
    right: -130px;
  }
  .mob-sm-menu-block{
    display: none;
  }
  @media only screen and (max-width: 1900px) {
    .dropdown-item{
      padding: 6px 15px;
    }
    .navbar-brand{
      margin-right: 10px;
    }
  }
  @media only screen and (max-width: 1800px) {
    .dropdown-item{
      padding: 6px 14px;
    }
    .navbar-brand{
      margin-right: 8px;
    }
  }
  @media only screen and (max-width: 1700px) {
    .mob-nav-item .dropdown-item{
      padding: 6px 20px 6px 0;
    }
    .mob-nav{
      width: 200px;
      flex-direction: column !important;
      position: absolute;
      z-index: 2000;
      top: 22px;
      right: -2px;
    }
    .mob-nav li a{
      font-size: 15px;
    }
    .mob-new-params{
      width: 100%;
      justify-content: space-between;
    }
    .email-inf-block svg path{
      fill: #1e7bb7;
    }
    .phoneNumber-inf-block svg path{
      fill: #1e7bb7;
    }
    .phone-spacing{
      margin: 5px 15px;
    }
    .email-inf-block svg{
      width: 16px;
    }
    .phoneNumber-inf-block svg{
      width: 16px;
    }
  } 
  @media only screen and (max-width: 1100px) {
    .mob-hide{
      display: none !important;
    }
    .mob-sm-menu-block{
      display: block;
    }
  }
  @media only screen and (max-width: 769px) {
    .navbar-brand img {
      width: 110px;
      height: 30px;
    }
    .mob-menu{
      width: 30px;
    }
  } 
  @media only screen and (max-width: 630px) {
    .land-login {
      font-size: 13px;
      width: 80px;
      height: 40px;
    }
    .land-auth {
      font-size: 13px;
      width: 80px;
      height: 40px;
    }
    .mob-contacts{
      display: none !important;
    }
  }
  @media only screen and (max-width: 600px) {
    .navbar-brand img {
      width: 90px;
      height: 23px;
    }
    .mob-menu{
      width: 25px;
    }
  } 
  @media only screen and (max-width: 500px) {
    .header-container{
      padding-left: 5%;
      padding-right: 5%;
    }
    .land-login {
      border-radius: 20px;
    }
    .land-auth {
      border-radius: 20px;
    }
  }
  @media only screen and (max-width: 400px) {
    .land-auth{
      margin-left: 5px;
    }
  }
</style>
